<section class="after-login cart-detail-section">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-strip my-5">
                    <h2 class="text-primary">Checkout</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-5 mb-lg-0">
                <div class="default-box rounded-4 p-4">
                    <div class="row">
                        <div class="col-lg-5 col-xl-4 mb-4 mb-lg-0">
                            <h6 class="text-primary mb-3">Card Details</h6>
                            <div class="rounded-4 inner-box p-4 bg-white">
                                <select (change)="changeCard(card)" class="form-control form-select"
                                    style="background-color: #e3edf4;" data-placeholder="Choose a Card" tabindex="1"
                                    [(ngModel)]="card">
                                    <option value="1">Select Card</option>
                                    @for (card of cardList; track $index) {
                                    <option value="{{ card.id }}">
                                        {{ card?.cc_number }}
                                    </option>
                                    }
                                </select>
                                <div class="text-end mt-3">
                                    <a (click)="changeCard(1)" class="text-secondary link cursor-pointer">Add New
                                        Card</a>
                                </div>
                            </div>
                            <form class="custom-addcard-form" id="addCreditCardFormInputs"
                                [formGroup]="addCreditCardForm" [hidden]="addNewCard" (ngSubmit)="addCreditCard()">
                                <div class="row mt-4">
                                    <div class="col-md-12 mb-3">
                                        <input class="form-control" type="text" trim="blur"
                                            placeholder="Card holder name" formControlName="cc_holder_name"
                                            id="cc_holder_name" name="cc_holder_name" />
                                        @if (
                                        (addCreditCardForm?.controls?.cc_holder_name?.touched
                                        ||addCreditCardForm?.controls?.cc_holder_name?.dirty || submittedNewCard)
                                        &&!addCreditCardForm?.controls?.cc_holder_name?.valid
                                        &&!addCreditCardForm?.controls?.cc_holder_name?.pending
                                        ) {
                                        @if (addCreditCardForm?.controls?.cc_holder_name?.errors.required) {
                                        <span class="text-danger error">Card Holder Name is required</span>
                                        }
                                        }
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <input class="form-control card_number" type="text" trim="blur"
                                            placeholder="Card number" formControlName="card_number" id="card_number"
                                            name="card_number" maxlength="19" ccNumber #ccNumber="ccNumber" />
                                        @if (
                                        (addCreditCardForm?.controls?.card_number?.touched
                                        ||addCreditCardForm?.controls?.card_number?.dirty ||submittedNewCard)
                                        &&!addCreditCardForm?.controls?.card_number?.valid
                                        &&!addCreditCardForm?.controls?.card_number?.pending
                                        ) {
                                        <span class="text-danger error">
                                            @if (addCreditCardForm?.controls?.card_number?.errors.required) {
                                            Card Number is required
                                            }
                                            @if (addCreditCardForm?.controls?.card_number?.value
                                            &&addCreditCardForm?.controls?.card_number?.errors.ccNumber) {
                                            Please Enter Valid Card Number
                                            }
                                        </span>
                                        }
                                    </div>
                                    <!-- </div> -->
                                    <!-- <div class="row mt-4"> -->
                                    <div class="col-md-12 mb-3">
                                        <input class="form-control" type="text" trim="blur" placeholder="MM / YY"
                                            formControlName="card_expiry" id="card_expiry" name="card_expiry" ccExp />
                                        @if (
                                        (addCreditCardForm?.controls?.card_expiry?.touched ||
                                        addCreditCardForm?.controls?.card_expiry?.dirty ||submittedNewCard)
                                        &&!addCreditCardForm?.controls?.card_expiry?.valid
                                        &&!addCreditCardForm?.controls?.card_expiry?.pending
                                        ) {
                                        <span class="text-danger error">
                                            @if (addCreditCardForm?.controls?.card_expiry?.errors.required) {
                                            Card Expiry Date is required
                                            }
                                            @if (addCreditCardForm?.controls?.card_expiry?.value
                                            &&addCreditCardForm?.controls?.card_expiry?.errors.expDate) {
                                            Please enter valid Expiry Date
                                            }
                                        </span>
                                        }
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <input class="form-control" maxlength="4" type="password" placeholder="CVV"
                                            formControlName="card_cvv" id="card_cvv" name="card_cvv" ccCVC />
                                        @if (
                                        (addCreditCardForm?.controls?.card_cvv?.touched
                                        ||addCreditCardForm?.controls?.card_cvv?.dirty ||submittedNewCard)
                                        &&!addCreditCardForm?.controls?.card_cvv?.valid
                                        &&!addCreditCardForm?.controls?.card_cvv?.pending
                                        ) {
                                        @if (addCreditCardForm?.controls?.card_cvv?.errors.minlength) {
                                        <span class="text-danger error">Minimum 3 digits required</span>
                                        }
                                        }
                                    </div>
                                </div>
                                @if (addCreditCardForm?.controls?.is_default?.value) {

                                <div class="col-md-12 row">
                                    <p class="m-l-10">
                                        <strong>Note:</strong>
                                        Now onwards, this new added card is used for all services
                                        and subscription scheduler.
                                    </p>
                                </div>
                                }
                                <div class="text-center text-lg-start">
                                    <button type="submit" name="button" class="btn btn-success btn-md me-2"
                                        [ladda]="isCardAdding">
                                        Save
                                    </button>
                                    <button type="button" name="button" class="btn btn-outline-success btn-md"
                                        (click)="cancelNewCard()">
                                        Cancel
                                    </button>
                                </div>
                            </form>

                        </div>
                        <div class="col-lg-7 col-xl-8">
                            <h6 class="text-primary mb-3">Cart ({{cartDetails?.items?.length}})</h6>
                            <div class="row">
                                @if (isItemNotRelatedSelectedoutpost) {
                                <div class="col-12">
                                    <div class="bottom-link mb-2">
                                        To continue with this order all items should be belongs to a
                                        same Center. So please change Center of respective items
                                    </div>
                                </div>
                                }
                                @for (cart of cartDetails?.items; track cart;let i = $index) {
                                <div class="col-12 mb-4">
                                    <div class="rounded-4 inner-box p-4 bg-white"
                                        [ngClass]="{'cart-item-error':cart?.isItemNotRelatedSelectedoutpost &&cart?.item_type !== 'product'}">

                                        @if (cart?.error_message) {
                                        <span class="text-danger error">{{cart?.error_message}}</span>
                                        }

                                        <div class="d-flex justify-content-between">
                                            <div class="d-flex">
                                                @if (cart?.item_type=='subscription') {
                                                <div class="img-box me-4 rounded-3 overflow-hidden">
                                                    <img [src]="filePath + cart?.plan?.id +'/cover_image/' +cart?.plan?.cover_image"
                                                        alt="" class="h-100 w-100"
                                                        onerror="this.src='assets/images/default_subscription.png'">
                                                </div>
                                                }
                                                @if (cart?.item_type=='product'){
                                                <div class="img-box me-4 rounded-3 overflow-hidden">
                                                    <img [src]="imagePath?.product +cart?.product_id +'/' +cart?.image"
                                                        alt="" class="h-100 w-100"
                                                        onerror="this.src='assets/images/default_product.png'">

                                                </div>
                                                }
                                                @if (cart?.item_type=='boarding'){
                                                <div class="img-box me-4 rounded-3 overflow-hidden">
                                                    <img [src]="imagePath?.cage +cart?.cage_type_id + '/cover_image/' +cart?.image"
                                                        alt="" class="h-100 w-100"
                                                        onerror="this.src='assets/images/default_cage.png'">

                                                </div>
                                                }
                                                @if (cart?.item_type=='grooming'){
                                                <div class="img-box me-4 rounded-3 overflow-hidden">
                                                    <img [src]="'assets/images/default_grooming.png'"
                                                        class="h-100 w-100">

                                                </div>
                                                }
                                                <div class="content-box">
                                                    <div class="text-primary">
                                                        @switch (cart?.item_type) {
                                                        @case ('subscription') {
                                                        {{ cart?.plan_level?.title }} ({{cart?.plan?.name }})
                                                        <img class="cursor-pointer"
                                                            [src]="!cart?.isItemNotRelatedSelectedoutpost  ? 'assets/images/outpost.png': 'assets/images/outpost_light.png'"
                                                            width="25" height="25" (click)="onSelect(cart)"
                                                            ngbTooltip="Select center" />
                                                        }
                                                        @case ('product') {
                                                        {{ cart?.title | titlecase }}
                                                        }
                                                        @case ('grooming') {
                                                        {{ cart?.plan_detail?.name | titlecase}}
                                                        <img class="cursor-pointer"
                                                            [src]="!cart?.isItemNotRelatedSelectedoutpost  ? 'assets/images/outpost.png': 'assets/images/outpost_light.png'"
                                                            width="25" height="25" (click)="onSelect(cart)"
                                                            ngbTooltip="Select center" />
                                                        }
                                                        @case ('boarding') {
                                                        {{ cart?.title | titlecase }}
                                                        <img class="cursor-pointer"
                                                            [src]="!cart?.isItemNotRelatedSelectedoutpost  ? 'assets/images/outpost.png': 'assets/images/outpost_light.png'"
                                                            width="25" height="25" (click)="onSelect(cart)"
                                                            ngbTooltip="Select center" />
                                                        }
                                                        }
                                                    </div>

                                                    @if(cart?.item_type=='subscription'){
                                                    <small>Subscription Charge</small>
                                                    <h6 class="text-info mb-0 mt-2">
                                                        {{ cart?.plan_level?.monthly_price | currency }}
                                                    </h6>
                                                    }@else if (cart?.item_type == 'product') {
                                                    <small>Product Price</small>
                                                    <h6 class="text-info mb-0 mt-2">
                                                        {{ cart?.product_price | currency }}
                                                    </h6>
                                                    <h6 class="text-info mb-0 mt-2">
                                                        Quantity : {{ cart?.quantity }}
                                                    </h6>
                                                    }@else if (cart?.item_type == 'grooming') {
                                                    <small>Grooming Plan Charge</small>
                                                    <h6 class="text-info mb-0 mt-2">
                                                        {{ cart?.plan_detail?.price | currency }}
                                                    </h6>


                                                    }@else if (cart?.item_type == 'boarding') {
                                                    <small>Cage Price</small>
                                                    <h6 class="text-info mb-0 mt-2">
                                                        {{ cart?.product_price | currency }}
                                                    </h6>
                                                    }

                                                </div>
                                            </div>
                                            <div>
                                                @if ( ['subscription', 'grooming', 'boarding'].includes(
                                                cart?.item_type
                                                )) {
                                                <a (click)="editCartItem(cart, cart?.item_type)" ngbTooltip="Edit Item"
                                                    class="delete-btn d-block mb-2 cursor-pointer">
                                                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 10.5H10.5" stroke="#526775" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path
                                                            d="M8.25 2.24816C8.44891 2.04925 8.7187 1.9375 9 1.9375C9.13929 1.9375 9.27721 1.96493 9.4059 2.01824C9.53458 2.07154 9.65151 2.14967 9.75 2.24816C9.84849 2.34665 9.92662 2.46358 9.97992 2.59226C10.0332 2.72095 10.0607 2.85887 10.0607 2.99816C10.0607 3.13745 10.0332 3.27537 9.97992 3.40406C9.92662 3.53274 9.84849 3.64967 9.75 3.74816L3.5 9.99816L1.5 10.4982L2 8.49816L8.25 2.24816Z"
                                                            stroke="#526775" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                </a>

                                                }
                                                <a (click)="removeItemFromCart(cart.id)" ngbTooltip="Delete Item"
                                                    class="delete-btn d-block text-danger cursor-pointer">
                                                    <i class="fa-solid fa-trash-can small"></i>
                                                </a>
                                            </div>
                                        </div>

                                        @if (cart?.item_type == 'subscription') {
                                        @if (cart?.extra_services?.length) {
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="text-primary mt-3 mb-2">Extra Services</div>
                                                @for (services of cart.extra_services; track services;let h = $index) {
                                                <div>
                                                    <i class="fa-solid fa-circle-check"></i>
                                                    <span>&nbsp;&nbsp;{{ services.title }}</span>

                                                    <strong class="text-primary">
                                                        {{services.monthly_price | currency}}
                                                    </strong>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                        }
                                        }
                                        @if (cart?.item_type == 'grooming') {
                                        <div class="row">
                                            @if (cart?.addon_detail?.length) {
                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2">Extra Services</div>
                                                @for (services of cart.addon_detail; track services;let h = $index) {
                                                <div>
                                                    <i class="fa-solid fa-circle-check"></i>
                                                    <span>&nbsp;&nbsp; {{ services.title }}</span>
                                                    <strong class="text-primary">
                                                        {{ services.price | currency }}
                                                    </strong>
                                                </div>
                                                }
                                            </div>
                                            }

                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2">Payment Info</div>
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <i class="fa-solid fa-circle-check"></i>
                                                        <span>&nbsp;&nbsp;Advanced Payment :&nbsp;</span>
                                                        <strong class="text-primary">{{ cart?.advance_payment |
                                                            currency }}</strong>
                                                    </div>
                                                    <a href="javascript:void(0)" class="delete-btn ms-1 small"
                                                        ngbTooltip="Change Advance Payment"
                                                        (click)="changeAdvancePayment(cart)">
                                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6 10.5H10.5" stroke="#526775" stroke-width="1.5"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                            <path
                                                                d="M8.25 2.24816C8.44891 2.04925 8.7187 1.9375 9 1.9375C9.13929 1.9375 9.27721 1.96493 9.4059 2.01824C9.53458 2.07154 9.65151 2.14967 9.75 2.24816C9.84849 2.34665 9.92662 2.46358 9.97992 2.59226C10.0332 2.72095 10.0607 2.85887 10.0607 2.99816C10.0607 3.13745 10.0332 3.27537 9.97992 3.40406C9.92662 3.53274 9.84849 3.64967 9.75 3.74816L3.5 9.99816L1.5 10.4982L2 8.49816L8.25 2.24816Z"
                                                                stroke="#526775" stroke-width="1.5"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </a>
                                                </div>
                                                <div>
                                                    <i class="fa-solid fa-circle-check"></i>
                                                    <span>&nbsp;&nbsp;Amount Paying Later :&nbsp;</span>
                                                    <strong class="text-danger">
                                                        {{
                                                        cart?.price -
                                                        cart?.advance_payment -
                                                        cart?.discount | currency
                                                        }}
                                                    </strong>
                                                </div>
                                            </div>

                                            @if (cart?.mandatory_product_detail?.length) {
                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2">Mandatory Products</div>
                                                @for (product of cart.mandatory_product_detail; track product;let h =
                                                $index) {
                                                <div>
                                                    <i class="fa-solid fa-circle-check"></i>
                                                    <span>&nbsp;&nbsp; {{ product.title }}</span>
                                                    <strong class="text-primary">
                                                        {{ product.price | currency }}
                                                    </strong>
                                                </div>
                                                }
                                            </div>
                                            }
                                            @if (
                                            cart?.holiday_detail &&
                                            cart?.holiday_detail?.title &&
                                            cart?.holiday_detail?.amount
                                            ) {
                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2">Extra Charges</div>
                                                <div>
                                                    <i class="fa-solid fa-circle-check"></i>
                                                    <span>&nbsp;&nbsp; {{ cart?.holiday_detail?.title }}</span>
                                                    <strong class="text-primary">
                                                        {{ cart?.holiday_detail?.amount | currency }}
                                                    </strong>
                                                </div>
                                            </div>
                                            }
                                            @if (cart?.discount_detail) {
                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2">Discount</div>
                                                <div>
                                                    <i class="fa-solid fa-circle-check"></i>
                                                    <span>&nbsp;&nbsp;{{ cart?.discount_detail?.title
                                                        }}&nbsp;({{
                                                        cart?.discount_detail?.rate
                                                        }}%)</span>
                                                    <strong class="text-danger">
                                                        -{{ cart?.discount | currency }}
                                                    </strong>
                                                </div>
                                            </div>
                                            }

                                        </div>
                                        }

                                        @if (cart?.item_type == 'boarding') {
                                        @for (pet of cart.pet_price_detail; track pet;let h = $index) {
                                        <h6 class="text-info mb-0 mt-2">
                                            Pet Name : {{ pet.name | titlecase }}
                                        </h6>
                                        <div class="row">
                                            @if (pet?.addon?.length) {
                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2"> Selected Add-ons For
                                                    {{ pet.name | titlecase }}</div>
                                                @for (services of pet.addon; track $index) {
                                                <div>
                                                    <i class="fa-solid fa-circle-check"></i>
                                                    {{ services.title | titlecase }} -
                                                    <span ngbTooltip="Selected Option">
                                                        {{ services?.selected_option }}
                                                    </span>
                                                    ({{ services.price | currency }}/Day *
                                                    {{ services.days }})
                                                    <strong class="text-primary">
                                                        {{ services.total_price | currency }}
                                                    </strong>
                                                </div>
                                                }
                                            </div>
                                            }
                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2">Payment Info</div>
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <i class="fa-solid fa-circle-check"></i>
                                                        <span>&nbsp;&nbsp;Advanced Payment :&nbsp;</span>
                                                        <strong class="text-primary">{{ cart?.advance_payment | currency
                                                            }}</strong>
                                                    </div>
                                                    <a href="javascript:void(0)" class="delete-btn ms-1 small"
                                                        ngbTooltip="Change Advance Payment"
                                                        (click)="changeAdvancePayment(cart)">
                                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6 10.5H10.5" stroke="#526775" stroke-width="1.5"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                            <path
                                                                d="M8.25 2.24816C8.44891 2.04925 8.7187 1.9375 9 1.9375C9.13929 1.9375 9.27721 1.96493 9.4059 2.01824C9.53458 2.07154 9.65151 2.14967 9.75 2.24816C9.84849 2.34665 9.92662 2.46358 9.97992 2.59226C10.0332 2.72095 10.0607 2.85887 10.0607 2.99816C10.0607 3.13745 10.0332 3.27537 9.97992 3.40406C9.92662 3.53274 9.84849 3.64967 9.75 3.74816L3.5 9.99816L1.5 10.4982L2 8.49816L8.25 2.24816Z"
                                                                stroke="#526775" stroke-width="1.5"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </a>
                                                </div>
                                                <div>
                                                    <i class="fa-solid fa-circle-check"></i>
                                                    <span>&nbsp;&nbsp;Amount Paying Later :&nbsp;</span>
                                                    <strong class="text-danger">{{
                                                        cart?.price -
                                                        cart?.advance_payment +
                                                        cart?.discount | currency
                                                        }}</strong>
                                                </div>
                                            </div>
                                            @if (pet.extra_price > 0) {
                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2">Extra Charges</div>
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <span>&nbsp;&nbsp;Pet Extra Price:&nbsp;</span>
                                                    <strong class="text-primary">
                                                        {{ pet.extra_price | currency }}
                                                    </strong>
                                                </div>
                                            </div>
                                            }
                                            @if (pet.products?.length) {
                                            <div class="col-lg-6">
                                                <div class="text-primary mt-3 mb-2">Selected Products For
                                                    {{ pet.name | titlecase }}</div>
                                                @for (product of pet.products; track $index) {
                                                <div>
                                                    {{ product.title | titlecase }}
                                                    <strong class="text-primary">
                                                        {{ product.price | currency }}
                                                    </strong>
                                                </div>
                                                }
                                            </div>
                                            }

                                        </div>
                                        }
                                        }

                                        <hr class="my-4">
                                        <div class="text-end text-info fw-bold fs-5">Total:
                                            <span>{{
                                                (cart?.item_type == "subscription"
                                                ? getPriceTotal(cart.plan_level.monthly_price, cart.extra_services) :
                                                cart?.item_type == "product" ? cart?.price: cart?.advance_payment )
                                                |currency }}</span>
                                        </div>
                                    </div>
                                </div>
                                }

                                <div class="col-12">
                                    <div
                                        class="text-info mb-4 rounded-4 p-3 total-box d-flex justify-content-between align-items-center">
                                        <span class="h6 m-0">Total Amount</span>
                                        <span class="h6 m-0 fw-bold"> {{ getTotalCartPrice() | currency }}</span>
                                    </div>
                                    <div class="text-center text-lg-end">
                                        <a [ladda]="isPayment" (click)="makePayment(card)"
                                            [ngClass]="{'disabled': card == '1' ||!cartDetails.items.length  ||cartHasError ||isItemNotRelatedSelectedoutpost}"
                                            [disabled]="card == '1' || !cartDetails.items.length ||cartHasError ||isItemNotRelatedSelectedoutpost"
                                            class="btn btn-success">Proceed To Payment</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="modal custom-modal" id="advance_payment_modal" tabindex="-1" role="dialog"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg zoomIn animated modal-bg-blue" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="text-info" id="exampleModalLongTitle">Advance Payment</h5>
                <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"
                    (click)="closeModal()"></button>
            </div>
            <div class="modal-body modal-min-height">
                <h6 class="text-primary mb-3">Payment Detail</h6>
                <ul>
                    <li class="d-flex justify-content-between align-items-center pb-3 mb-3 dash-border">
                        <span>{{
                            advanceSelectedPlan?.item_type == "grooming" ? "Plan" : "Cage"
                            }}
                            Price</span>
                        <span class="text-primary fw-bold">{{
                            advanceSelectedPlan?.product_price | currency
                            }}</span>
                    </li>
                    <li class="d-flex justify-content-between align-items-center pb-3 mb-3 dash-border">
                        <span>Add-on Price</span>
                        <span class="text-primary fw-bold">{{
                            advanceSelectedPlan?.addon_ammount | currency
                            }}</span>
                    </li>
                    <li class="d-flex justify-content-between align-items-center pb-3 mb-3 dash-border">
                        <span>Product Price</span>
                        <span class="text-primary fw-bold">{{
                            advanceSelectedPlan?.mandatory_product_amount | currency
                            }}</span>
                    </li>
                    <li class="d-flex justify-content-between align-items-center pb-3 mb-3 dash-border">
                        <span>Discount</span>
                        <span class="text-primary fw-bold">-{{
                            advanceSelectedPlan?.discount | currency
                            }}</span>
                    </li>
                    <li class="d-flex justify-content-between align-items-center pb-3 mb-3 dash-border">
                        <span class="text-info link fs-5">Payable Amount</span>
                        <span class="text-info fs-5 fw-bold">{{
                            advanceSelectedPlan?.price - advanceSelectedPlan?.discount
                            | currency
                            }}</span>
                    </li>
                </ul>
                <div class="form-checkbox d-flex align-items-center mt-4">
                    <input type="checkbox" name="checkbox" id="advancePayCheckbox" [(ngModel)]="is_advance_amount"
                        class="form-check-input me-2 mt-0" />
                    <label class="form-check-label" for="advancePayCheckbox">I would like to pay in advance for this
                        booking</label>
                </div>
                @if (is_advance_amount) {
                <div class="row">
                    <div class="col-12 mt-3">
                        <label class="text-primary small mb-1">Amount ($)</label>
                        <input class="form-control" type="number" [(ngModel)]="updatedAmount"
                            (change)="calculateMinimumAmount(updatedAmount)" />
                        <small class="text-danger error">
                            @if (minimumPaymentFlag) {
                            Un-check above check-box to continue without advance payment
                            }
                            @if (maximumPaymentFlag) {
                            Advance Booking Amount should be less than or equal to
                            Payable Amount
                            }
                        </small>
                    </div>
                </div>
                }
            </div>
            <div class="modal-footer">
                <div class="form-button">
                    <button class="btn btn-success" (click)="updateCart()" type="button"
                        [disabled]="(is_advance_amount && minimumPaymentFlag) || (is_advance_amount && maximumPaymentFlag)"
                        [ladda]="cartProcess">
                        <span>Submit</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Edit Grooming Plan Modal -->
<app-grooming-plan-modal [petDetails]="groomingPetDetail" [planDetails]="groomingPlanDetail"
    [isChangeClinic]="isChangeClinic" [showGroomingPlanModal]="showGroomingModal"
    (closeGroomingPlanModal)="closePlanModal($event)">
</app-grooming-plan-modal>

<!-- Edit Boarding Plan Modal -->
<app-cage-booking-modal [bookingPetDetails]="boardingPetDetail" [planDetails]="boardingPlanDetail"
    [showPlanModal]="showBoardingModal" (closePlanModal)="closeBoardingPlanModal($event)">
</app-cage-booking-modal>